// API URL
let apipath = '';
let r1Path = '';
let apsPath = '';
let portalPath = '';
let portalMainPath = '';
let bnzURL = '';
let bankdata = '';
let gqlPath = '';
switch (process.env.BANKDATA_ENV) {
  case 'production':
    apipath = 'https://bankdata.reckonapi.com';
    r1Path = 'https://app.reckonone.com/';
    apsPath = 'https://bankdata-report.access-aps.com/';
    portalPath = 'https://portal-backend.reckonapi.com';
    portalMainPath = 'https://portal.reckon.com';
    bankdata = 'https://bankdata-web.reckon.com';
    gqlPath = 'https://graphql.reckonapi.com/graphql';
    bnzURL =
      'https://secure.bnz.co.nz/pingfederate/as/authorization.oauth2?response_type=code&client_id=UlOAf8mhnYKyIh7ZHGjTLWdAJmYhlm6H&redirect_uri=https://bankdata.reckonapi.com/bnz/callback&scope=bankfeeds&state=';
    break;
  case 'staging':
    apipath = 'https://bankdata-api.reckoncloud.com.au';
    r1Path = 'https://app.reckoncloud.com.au/';
    apsPath = 'https://bankdata-report.access-aps.com/';
    portalPath = 'https://portal-backend.reckoncloud.com.au';
    portalMainPath = 'https://tesla.reckoncloud.com.au/';
    bankdata = 'https://bankdata-web.dev.reckoncloud.com.au';
    gqlPath = 'https://graphql.stg.reckonapi.com/graphql';
    bnzURL =
      'https://secure.sandbox.bnz.co.nz/pingfederate/as/authorization.oauth2?response_type=code&client_id=VD9ww2IxRnUWtTUYipeDx33GUTYHJRpn&redirect_uri=https://bankdata-api.dev.reckoncloud.com.au/bnz/callback&scope=bankfeeds&state=';
    break;
  default:
    // apipath = 'https://bankdata.reckonapi.com';
    // r1Path = 'https://app.reckon.com/';

    apipath = 'https://bankdata-api.dev.reckoncloud.com.au';
    r1Path = 'https://reckonone.dev.reckoncloud.com.au/';
    apsPath = 'https://bankdata-report.dev.aps.reckon.com/';
    portalPath = 'https://portal-backend.dev.reckoncloud.com.au';
    portalMainPath = 'https://genesis.dev.reckoncloud.com.au/';
    bankdata = 'https://bankdata-web.dev.reckoncloud.com.au';
    gqlPath = 'https://graphql.dev.reckonapi.com/graphql';
    bnzURL =
      'https://secure.sandbox.bnz.co.nz/pingfederate/as/authorization.oauth2?response_type=code&client_id=VD9ww2IxRnUWtTUYipeDx33GUTYHJRpn&redirect_uri=https://bankdata-api.dev.reckoncloud.com.au/bnz/callback&scope=bankfeeds&state=';

    // apipath = 'http://localhost:1368';
    // r1Path = 'http://reckonone.dev.reckoncloud.com.au/';
    break;
}

export const ROOT_URL = apipath;
export const R1_URL = r1Path;
export const APS_URL = apsPath;
export const PORTAL_URL = portalPath;
export const PORTAL_MAIN_URL = portalMainPath;
export const BNZ_URL = bnzURL;
export const BANKDATA_URL = bankdata;
export const GQL_URL = gqlPath;

// Transactions
export const GET_TRANSACTIONS = 'get_transactions';
export const UPDATE_TRANSACTIONS = 'update_transactions';
export const SELECT_TRANSACTION = 'select_transaction';
export const DESELECT_TRANSACTION = 'deselect_transaction';
export const SELECT_TRANSACTIONS = 'select_transactions';
export const NEW_TRANSACTIONS = 'new_transactions';
export const GET_BANK_ACCOUNTS = 'get_bank_accounts';
export const GET_CHART = 'get_chart';
export const GET_CONTACTS = 'get_contacts';
export const GET_PROJECTS = 'get_projects';
export const GET_TAX_PREFERENCE = 'get_tax_preference';
export const SET_CURRENT_BOOK = 'set_current_book';
export const GET_CLASSIFICATION = 'get_classification';
export const IS_SAVING = 'is_saving';
export const IS_SAVED = 'is_saved';
export const LOAD_COMPLETED = 'load_completed';
export const SET_CODED = 'set_coded';
export const CODED_BY_R1_RULE = 'coded_by_r1_rule';
export const UPDATE_MATCHES = 'update_matches';
export const SORT_ROWS = 'sort_rows';
export const QUEUE_TRANSACTION_UPDATE = 'QUEUE_TRANSACTION_UPDATE';
export const UPDATE_FILTERBY = 'update_filterby';
export const TRANSACTION_CODING_ERROR = 'transaction_coding_error';
export const IS_LOADING_TRANSACTIONS = 'is_loading_transactions';

// Bankfeeds
export const GET_BANKFEEDS = 'get_bankfeeds';
export const CLEAR_BANKFEEDS = 'clear_bankfeeds';
export const BANKFEEDS_SET_API_ERROR = 'bankfeeds_set_api_error';
export const BANKFEEDS_LOAD_COMPLETED = 'bankfeeds_load_completed';
export const GET_BANKFEED_OPTIONS = 'get_bankfeed_options';
export const REQUEST_BANKFEED_SHARES = 'request_bankfeed_shares';
export const GET_BANKFEED_SHARES = 'get_bankfeed_shares';
export const REQUEST_ADD_BANKFEED_SHARE = 'request_add_bankfeed_share';
export const ADD_BANKFEED_SHARE = 'add_bankfeed_share';
export const ADD_BANKFEED_SHARE_FAILURE = 'add_bankfeed_share_failure';
export const REQUEST_DELETE_BANKFEED_SHARE = 'request_delete_bankfeed_share';
export const DELETE_BANKFEED_SHARE = 'delete_bankfeed_share';
export const DELETE_BANKFEED_SHARE_FAILURE = 'delete_bankfeed_share_failure';
export const REQUEST_SEND_EMAIL = 'request_send_email';
export const SEND_EMAIL = 'send_email';
export const SEND_EMAIL_FAILURE = 'send_email_failure';
export const CLEAR_SHARE_STATE = 'clear_share_state';
export const GET_SISS_URL = 'get_siss_url';

// Other
export const NO_ACTION = 'no-action';
export const SET_API_ERROR = 'set_api_error';
export const POSTING = 'posting';
export const COMPLETED = 'completed';
export const SET_POLL_INTERVAL = 'SET_POLL_INTERVAL';
export const SET_LAST_SYNC = 'SET_LAST_SYNC';
export const QUEUE_STATE = 'QUEUE_STATE';

// Rules
export const GET_RULES = 'get_rules';
export const CLEAR_RULE = 'clear_rule';

// Match
export const GET_BILLS = 'get_bills';
export const GET_INVOICES = 'get_invoices';
export const GET_UNDEPOSTED = 'get_undeposited';
export const MATCH_LIST_START = 'match_list_start';
export const MATCH_LIST_ERROR = 'match_list_error';
export const CLEAR_MATCH = 'clear_match';
export const CODING_SETTLED = 'coding_settled';
export const REMOVE_MATCH_BUTTON = 'remove_match_button';
export const RESTORE_MATCH_BUTTON = 'restore_match_button';
export const START_MATCH_LOADING = 'start_match_loading';
export const STOP_MATCH_LOADING = 'stop_match_loading';

// XPA
export const GET_FEEDS = 'get_feeds';
export const LINK_FEED = 'link_feed';
export const TOGGLE_FIELD = 'toggle_field';
export const REQUEST_UPDATE_FEED_ACCOUNTNAME = 'request_update_feed_accountname';
export const UPDATE_FEED_ACCOUNTNAME_SUCCESS = 'update_feed_accountname_success';
export const UPDATE_FEED_ACCOUNTNAME_FAILURE = 'update_feed_accountname_failure';
export const GET_USER_ID = 'get_user_id';
export const GET_MAP_BANKS = 'get_map_banks';
export const GET_RAH_BANKACCOUNTS = 'get_rah_bankaccounts';
export const REQUEST_LOGIN = 'request_login';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAILURE = 'login_failure';
export const LOGOUT = 'logout';
export const REQUEST_RESET_PASSWORD = 'request_reset_password';
export const RESET_PASSWORD_SUCCESS = 'reset_password_success';
export const RESET_PASSWORD_FAILURE = 'reset_password_failure';
export const REQUEST_SET_PASSWORD = 'request_set_password';
export const SET_PASSWORD_SUCCESS = 'set_password_success';
export const SET_PASSWORD_FAILURE = 'set_password_failure';
export const SET_PASSWORD_TOKEN_INVALID = 'set_password_token_invalid';
export const CLEAR_XPA_STATE = 'clear_xpa_state';
export const REQUEST_FAILURE = 'request_failure';
export const NO_ERROR_RESPONSE = 'no_error_response';
export const SET_ERROR = 'set_error';

// Send To Client
export const SEND_TO_CLIENT = 'send_to_client';

// GA
export const TRACKING_CODE = process.env.BANKDATA_ENV === 'production' ? 'UA-67802510-1' : 'UA-67802510-2';

// Comments
export const GET_COMMENTS = 'get_comments';
export const DELETE_COMMENT = 'delete_comment';

// URLS
export const CBA_FORM_HELP =
  'https://help.reckon.com/article/d3de91651b-commonwealth-bank-filling-out-the-authorisation-form';



// WEBPACK FOOTER //
// ./src/Actions/types.js